export default __webpack_public_path__ + "static/media/github-dots.fc1e4dd8.svg";